/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 1/12/2021
 */

import DbBaseObject from "@shared/DbBaseObject";

export default class RangeItem extends DbBaseObject {

	min: number = 0
	max: number = 0
	label: string = ""


	constructor(min: number, max: number, label: string) {
		super();
		this.min = min || 0;
		this.max = max || 0;
		this.label = label || "";
	}

	get range(){
		return [this.min, this.max]
	}

	set range([min, max]){
		this.min = min
		this.max = max
	}


}
